// extracted by mini-css-extract-plugin
module.exports = {"root":"_bd1347","icon":"_963454"};